import React from 'react';
import { DefinitionList, Text } from '@moda/om';
import { SizeInventoryFragment } from '../../generated/types/SizeInventoryFragment';

interface Props {
  selectedSize: SizeInventoryFragment | null;
}

const LOW_INVENTORY_AMOUNT = 3;

export const ProductDetailsSizeInventory: React.FC<Props> = ({ selectedSize }) => {
  if (!selectedSize) {
    return <DefinitionList term="Size">Please select a size</DefinitionList>;
  }
  if (!selectedSize.canSell) {
    return <DefinitionList term="Size">{selectedSize.size} (Sold Out)</DefinitionList>;
  }
  if (
    selectedSize?.available &&
    selectedSize.canSell &&
    selectedSize.available <= LOW_INVENTORY_AMOUNT
  ) {
    return (
      <DefinitionList term="Size">
        {selectedSize?.size}
        <Text color="code-red"> — Only {selectedSize?.available} Left</Text>
      </DefinitionList>
    );
  }
  return <DefinitionList term="Size">{selectedSize.size}</DefinitionList>;
};
